const AdaptiveEventImage = ({
	src,
	alt,
	height,
	containerClasses,
	width,
	className,
	loading,
	fetchPriority,
}) => {
	const effectiveClassName = className || "event-image";
	const effectiveContainerClasses = `event-image-container rounded ${containerClasses}`;

	return (
		<div className={effectiveContainerClasses}>
			<div
				className="blurred-background"
				style={{
					backgroundImage: `url(${src})`,
				}}
			/>
			<img
				src={src}
				className={effectiveClassName}
				alt={alt}
				height={height}
				width={width}
				loading={loading}
				fetchpriority={fetchPriority}
			/>
		</div>
	);
};

export default AdaptiveEventImage;
